import n, { forwardRef as g, useRef as I, useEffect as b } from "react";
import { useTheme as v, Button as C, CircularProgress as h } from "@mui/material";
import { I as u } from "./chunk.zlc_6vey.js";
import { g as B } from "./chunk.BurCwd5X.js";
const R = g(
  ({
    variant: d = "contained",
    iconVariant: i,
    buttonText: r,
    ...e
  }, o) => {
    const a = v(), c = I(null);
    b(() => {
      e.autoFocus && setTimeout(() => {
        var t;
        (t = c.current) == null || t.focusVisible();
      }, 0);
    }, []);
    const s = (t) => {
      var l;
      t.stopPropagation(), (l = e.onClick) == null || l.call(e, t);
    }, f = () => {
      if (e.loading)
        return /* @__PURE__ */ n.createElement(
          h,
          {
            sx: {
              color: a.palette.grey[400]
            },
            size: a.spacing(3),
            "aria-label": "Circular Progress"
          }
        );
      if (e.startIcon) {
        const t = {
          variant: i,
          icon: e.startIcon,
          disabled: e.disabled
        };
        return /* @__PURE__ */ n.createElement(u, { ...t });
      }
    }, m = () => {
      if (e.endIcon) {
        const t = {
          variant: i,
          icon: e.endIcon
        };
        return /* @__PURE__ */ n.createElement(u, { ...t });
      }
    };
    return /* @__PURE__ */ n.createElement(
      C,
      {
        id: e.id,
        variant: d,
        disabled: e.disabled || e.loading,
        onClick: e.onClick ? s : void 0,
        size: "large",
        fullWidth: e.fullWidth ? e.fullWidth : !1,
        startIcon: f(),
        endIcon: m(),
        disableRipple: !0,
        disableElevation: !0,
        type: e.type,
        "data-testid": e["data-testid"],
        ref: o,
        onBlur: e.onBlur,
        onFocus: e.onFocus,
        onMouseOver: e.onMouseOver,
        onMouseLeave: e.onMouseLeave,
        action: c,
        ...B(o)
      },
      r
    );
  }
);
export {
  R as B
};
